import React, { useState } from "react";
import Editor from "@monaco-editor/react";
import "../CodeConverter.css";
import { FaDownload, FaCompress, FaBrush, FaCopy, FaCheck, FaTrash } from "react-icons/fa";
import JsonEditorPanel from "../components/JsonEditorPanel";
//import SEOContent from '../components/SEOContent';
import CommonSeoContent from "../components/CommonSeoContent";
import useEditorActions from "../utils/useEditorActions";


const JsonFormatter = () => {
  const [inputCode, setInputCode] = useState("");
  const [outputCode, setOutputCode] = useState("");

  // Import reusable actions
  const { handleDownload, handleClear } = useEditorActions(
    setInputCode,
    outputCode,
    setOutputCode
  );


  // Beautify JSON
  const handleBeautify = () => {
    try {
      const parsed = JSON.parse(inputCode);
      setOutputCode(JSON.stringify(parsed, null, 2)); // pretty print
    } catch (error) {
      setOutputCode("// ❌ Invalid JSON:\n" + error.message);
    }
  };

  // Minify JSON
  const handleMinify = () => {
    try {
      const parsed = JSON.parse(inputCode);
      setOutputCode(JSON.stringify(parsed)); // minify
    } catch (error) {
      setOutputCode("// ❌ Invalid JSON:\n" + error.message);
    }
  };


  return (
    <div className="formatter-container">
      <h1>JSON Formatter</h1>

      {/* Toolbar */}
      <div className="toolbar">
        <button onClick={handleBeautify} className="btn primary">
          <FaBrush /> Beautify
        </button>
        <button onClick={handleMinify} className="btn">
          <FaCompress /> Minify
        </button>
        <button onClick={() => handleDownload("json", "formatted-json")} className="btn success">
          <FaDownload /> Download
        </button>
		<button onClick={handleClear} className="btn danger">
          <FaTrash /> Clear
        </button>
      </div>
      {/* Editors */}
      <div className="editor-panels">
        <JsonEditorPanel title="Input JSON" language="json" code={inputCode} setCode={setInputCode} />
        <div className="editor-section-empty-div">

        </div>
        <JsonEditorPanel title="Output JSON" language="json"  code={outputCode} />
      </div>
      
	  <CommonSeoContent
  title="Online JSON Converter & Formatter – Code, XML & CSV Tools"
  description="Free online JSON tools for formatting, validating, and converting JSON to XML, YAML, CSV, and multiple programming languages. Supports JSON, XML, YAML, and CSV transformations — secure, fast, and completely browser-based."
  keywords="JSON converter, JSON formatter, JSON validator, JSON to XML, JSON to YAML, JSON to CSV, JSON to Java, JSON to PHP, JSON to Python, JSON to Go, XML formatter, YAML converter, csv to json, jsonconverter.org, json code converter, json formatter, json beautifier, json validator, online json formatter, json formatter online, json beautify, beautify json, format json, jsonlint, JSON Checker, JSON Cleaner, json converter, json format, json online format, format json online, json formatter, xml formatter, json to java, json to c, json to c++, json to c#, json to python, csv to json, online formatter, json to code converter, json to code generator, data converter, json tools, developer tools"
  author="jsonconverter.org"
  heading="What is JSONConverter.org?"
  whyUseText="JSONConverter.org is a free and powerful online toolbox designed for developers, data engineers, and analysts who work with JSON, XML, YAML, and CSV data formats. It allows you to format, validate, and convert data quickly and securely — all within your browser. No data is sent to any server, making it safe for confidential or production-level usage. Whether you're debugging a JSON API response, converting CSV into structured objects, or generating class models in your favorite language, our tools save time and reduce manual effort."
  howToUseSteps={[
    "Paste or upload your JSON, XML, YAML, or CSV file in the editor.",
    "Choose the desired tool or conversion option.",
    "Click the Convert or Format button.",
    "View your output instantly, copy it, or download the result.",
  ]}
  features={[
    "Format and minify JSON with optional download support",
    "Convert JSON to XML, YAML, or CSV in real-time",
    "Upload CSV and get clean, formatted JSON instantly",
    "Generate data models from JSON in Java, PHP, C, C++, C#, Python, or Go",
    "Format and validate XML or convert it to JSON",
    "Beautify YAML or convert it into structured JSON",
    "100% browser-based — no file uploads or backend processing",
    "Completely free, fast, and secure — no login or installation required",
  ]}
  inputTitle="Supported Tools & Converters:"
  inputExample={`• JSON Formatter & Minifier
• JSON to XML Converter
• JSON to YAML Converter
• JSON to CSV Converter
• CSV to JSON Formatter (Upload Support)
• JSON to Java / PHP / C / C++ / C# / Python / Go
• XML Formatter & XML to JSON Converter
• YAML Formatter & YAML to JSON Converter`}
  outputTitle="Output Preview (JSON to YAML):"
  outputExample={`{
  "name": "John",
  "active": true,
  "roles": ["admin", "editor"]
}

# Converted YAML:
name: John
active: true
roles:
  - admin
  - editor`}
  callToAction="Start using JSONConverter.org now — no signup, no installation, just fast and secure data tools at your fingertips."
/>

	  
    </div>
  );
};

export default JsonFormatter;